import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { NotifMessageService } from './notifmessage.service';
import { catchError, map } from 'rxjs/operators';
import { MerchantSciId } from '../models/merchantSciId';


@Injectable({ providedIn: 'root' })
export class MerchantSciService {

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private notifService: NotifMessageService
    ) { }

    sciSaveNeededSubject = new Subject<any[]>();
    sciSubject = new Subject<Array<MerchantSciId>>();

    getSciListByMerchantId(merchantId): Observable<Array<String>> {
        return this.http.get<any>(`${this.configService.config.urlAPI.urlSci}/${merchantId}`).pipe(catchError(err => {
            if (err.status == "404") {
                console.log("error", err);
            } else {
                this.notifService.notifyErrorWithDetailFromApi('ERROR_SEPA_SCI_API', err);
            }
            let emptyItem = new Array<MerchantSciId>();
            return of(emptyItem);
        }));
    }

    deleteSci(id: MerchantSciId): Observable<MerchantSciId> {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: id };
        return this.http.delete<MerchantSciId>(this.configService.config.urlAPI.urlSci, httpOptions).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_SEPA_SCI_API', err);
            return of(null);
        }));
    }


    createSci(sci: MerchantSciId): Observable<MerchantSciId> {
        return this.http.post<MerchantSciId>(this.configService.config.urlAPI.urlSci, sci).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_SEPA_SCI_API', err);
            return of(null);
        }));
    }

}
